import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { Configuration } from './configuration';
import { HttpClient } from '@angular/common/http';

import { AreaKoeficientService } from './api/areaKoeficient.service';
import { AreaPriceService } from './api/areaPrice.service';
import { AuthorizationService } from './api/authorization.service';
import { AuthorizationPasswordService } from './api/authorizationPassword.service';
import { CalculationService } from './api/calculation.service';
import { CalculationTypeService } from './api/calculationType.service';
import { ColorService } from './api/color.service';
import { CustomerService } from './api/customer.service';
import { RoleService } from './api/role.service';
import { ServiceService } from './api/service.service';
import { ServiceAreaPriceService } from './api/serviceAreaPrice.service';
import { StatsService } from './api/stats.service';
import { UserService } from './api/user.service';

@NgModule({
  imports:      [],
  declarations: [],
  exports:      [],
  providers: []
})
export class ApiModule {
    public static forRoot(configurationFactory: () => Configuration): ModuleWithProviders<ApiModule> {
        return {
            ngModule: ApiModule,
            providers: [ { provide: Configuration, useFactory: configurationFactory } ]
        };
    }

    constructor( @Optional() @SkipSelf() parentModule: ApiModule,
                 @Optional() http: HttpClient) {
        if (parentModule) {
            throw new Error('ApiModule is already loaded. Import in your base AppModule only.');
        }
        if (!http) {
            throw new Error('You need to import the HttpClientModule in your AppModule! \n' +
            'See also https://github.com/angular/angular/issues/20575');
        }
    }
}
